/**
 * Wyde Footwear — AMP cart Figma experiment (Convert)
 *
 * window.__WYDE_AMP_FIGMA__ = {
 *   thresholds: { USD: 20000, SEK: 50000, EUR: 10000, ... }, // cart.js total_price units (öre/cents)
 *   locale: 'en' | 'sv' | 'auto'
 * };
 */
(function () {
    if (window.__WYDE_AMP_CART_FIGMA_THEME__) return;
    window.__WYDE_AMP_CART_FIGMA_THEME__ = true;
  
    var CFG = window.__WYDE_AMP_FIGMA__ || {};
    var DEFAULT_THRESHOLDS = { USD: 20000, SEK: 50000, EUR: 10000, GBP: 13500, NOK: 200000 };
    /** Only rebuild scroll wrapper on mobile/desktop switch — never during line-item React updates (avoids 422 / broken qty). */
    var wydeAmpScrollLayoutMode = null;
  
    /** Shopify Files — USP row icons */
    var USP_IMG = {
      calendar:
        'https://cdn.shopify.com/s/files/1/0677/3352/0703/files/Group_2.png?v=1778502922',
      shield: 'https://cdn.shopify.com/s/files/1/0677/3352/0703/files/img_2.png?v=1775659357',
      klarna:
        'https://cdn.shopify.com/s/files/1/0677/3352/0703/files/klarna-637a076e_svg.png?v=1775659388'
    };
  
    /** Shopify Files — payment row (single SVG per brand) */
    var PAY_CARD_IMG = {
      visa:
        'https://cdn.shopify.com/s/files/1/0677/3352/0703/files/visa-65d650f7_svg.svg?v=1775660368',
      /* Amex: add `american_express-…_svg.svg` in Files if missing; placeholder matches Figma export name */
      amex:
        'https://cdn.shopify.com/s/files/1/0677/3352/0703/files/american_express-1efdc6a3_svg.svg?v=1775660375',
      mc: 'https://cdn.shopify.com/s/files/1/0677/3352/0703/files/master-54b5a7ce_svg.svg?v=1775660382',
      apple:
        'https://cdn.shopify.com/s/files/1/0677/3352/0703/files/apple_pay-1721ebad_svg.svg?v=1775660392',
      google:
        'https://cdn.shopify.com/s/files/1/0677/3352/0703/files/google_pay-34c30515_svg.svg?v=1775660398',
      paypal:
        'https://cdn.shopify.com/s/files/1/0677/3352/0703/files/paypal-a7c68b85_svg.svg?v=1775660405',
      shop: 'https://cdn.shopify.com/s/files/1/0677/3352/0703/files/shopify_pay-925ab76d_svg.svg?v=1775660410'
    };
  
    function thresholdFor(currency) {
      var t = CFG.thresholds && CFG.thresholds[currency];
      if (t != null) return t;
      return DEFAULT_THRESHOLDS[currency] != null ? DEFAULT_THRESHOLDS[currency] : null;
    }
  
    var COPY = {
      en: {
        usp: [
          { text: '30-day easy returns', icon: 'calendar' },
          { text: 'Secure checkout', icon: 'shield' },
          { text: 'Buy now, pay later', icon: 'klarna' }
        ],
        progressRemainingHtml: function (money) {
          return (
            'Add <strong>' +
            money +
            '</strong> more to get <span class="wyde-amp-figma-rewards-accent" style="color: #000 !important;">Free Shipping</span>'
          );
        },
        progressDone:
          'Your order qualifies for <span class="wyde-amp-figma-rewards-accent">Free Shipping</span>',
        shippingAtCheckout: 'Calculated at checkout',
        shippingFree: 'Free',
        sizeLine: function (label) {
          return 'Size: ' + label;
        }
      },
      sv: {
        usp: [
          { text: '30 dagars enkel retur', icon: 'calendar' },
          { text: 'Säker kassa', icon: 'shield' },
          { text: 'Köp nu, betala senare', icon: 'klarna' }
        ],
        progressRemainingHtml: function (money) {
          return (
            'Lägg till <strong>' +
            money +
            '</strong> till för att få <span class="wyde-amp-figma-rewards-accent" style="color:#000 !important;">fri frakt</span>'
          );
        },
        progressDone:
          'Din beställning kvalificerar sig <span class="wyde-amp-figma-rewards-accent">fri frakt</span>',
        shippingAtCheckout: 'Beräknas i kassan',
        shippingFree: 'Gratis',
        sizeLine: function (label) {
          return 'Storlek: ' + label;
        }
      }
    };
  
    function detectLang() {
      if (CFG.locale && COPY[CFG.locale]) return CFG.locale;
      var h = document.documentElement.getAttribute('lang') || '';
      if (/^sv\b/i.test(h)) return 'sv';
      return 'en';
    }

    /**
     * Swedish storefront: "325,00 kr" (suffix), not "SEK 325.00" from currency style.
     */
    function formatProgressRemainingMoney(cart, amountCents) {
      var amount = amountCents / 100;
      var lang = detectLang();
      if (lang === 'sv' && cart.currency === 'SEK') {
        return (
          new Intl.NumberFormat('sv-SE', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          }).format(amount) + ' kr'
        );
      }
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: cart.currency
      }).format(amount);
    }
  
    function iconHtml(kind) {
      var src = USP_IMG[kind];
      if (!src) return '';
      return (
        '<img class="wyde-amp-figma-usp__icon wyde-amp-figma-usp__icon--img" src="' +
        src +
        '" alt="" width="24" height="24" loading="lazy" decoding="async" />'
      );
    }
  
    function buildUspHtml() {
      var lang = detectLang();
      var pack = COPY[lang] || COPY.en;
      return pack.usp
        .map(function (row) {
          return (
            '<div class="wyde-amp-figma-usp__item">' +
            iconHtml(row.icon) +
            '<span class="wyde-amp-figma-usp__text">' +
            row.text +
            '</span></div>'
          );
        })
        .join('');
    }
  
    /**
     * Place USP directly above the coupon. AMP inserts an empty `.amp-cart__upsell`
     * after cart lines — if we only inject after lines, USP sits above that empty
     * block and a white gap appears (Figma has USP flush above coupon).
     */
    function ensureUspStrip() {
      var root = document.querySelector('#amp-theme-extension .amp-cart-drawer--scrollable');
      if (!root) return;
  
      var discount = root.querySelector('.amp-cart__discount-box');
      var usp = root.querySelector('.wyde-amp-figma-usp');
  
      if (usp && discount && usp.nextElementSibling !== discount) {
        discount.parentNode.insertBefore(usp, discount);
      }
  
      if (usp) return;
  
      if (!discount && !root.querySelector('.amp-cart__cart-lines')) return;
  
      var wrap = document.createElement('div');
      wrap.className = 'wyde-amp-figma-usp';
      wrap.setAttribute('role', 'region');
      wrap.setAttribute('aria-label', 'Benefits');
      wrap.innerHTML = buildUspHtml();
  
      if (discount && discount.parentNode) {
        discount.parentNode.insertBefore(wrap, discount);
      } else {
        var host = root.querySelector('.wyde-amp-figma-lines-scroll-host');
        var lines = root.querySelector('.amp-cart__cart-lines');
        var anchor = host || lines;
        if (anchor && anchor.parentNode) {
          anchor.insertAdjacentElement('afterend', wrap);
        }
      }
    }
  
    function wireCouponAccordion() {
      var box = document.querySelector('#amp-theme-extension .amp-cart__discount-box');
      if (!box || box.dataset.wydeFigmaCouponWired) return;
      var title = box.querySelector('.amp-cart__discount-box-title');
      var form = box.querySelector('.amp-cart__discount-box-form');
      if (!title || !form) return;
      box.dataset.wydeFigmaCouponWired = '1';
      title.setAttribute('role', 'button');
      title.setAttribute('tabindex', '0');
      title.setAttribute('aria-expanded', 'false');
  
      function toggle() {
        var open = box.classList.toggle('wyde-amp-figma-coupon-open');
        title.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
  
      title.addEventListener('click', function (e) {
        e.preventDefault();
        toggle();
      });
      title.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          toggle();
        }
      });
    }
  
    function ensureProgressWrap(rewards) {
      var wrap = rewards.querySelector('.wyde-amp-figma-progress-wrap');
      if (wrap) return wrap;
      wrap = document.createElement('div');
      wrap.className = 'wyde-amp-figma-progress-wrap';
      wrap.innerHTML =
        '<div class="wyde-amp-figma-rewards-text" aria-live="polite"></div>' +
        '<div class="wyde-amp-figma-progress-track">' +
        '<div class="wyde-amp-figma-progress-fill"></div>' +
        '</div>';
      rewards.insertBefore(wrap, rewards.firstChild);
      return wrap;
    }
  
    function removeProgressWrap(rewards) {
      var w = rewards.querySelector('.wyde-amp-figma-progress-wrap');
      if (w && w.parentNode) w.parentNode.removeChild(w);
    }
  
    var progressFetchTimer = null;

    function sizeLabelFromLineItem(item) {
      if (!item) return '';
      var opts = item.options_with_values;
      if (opts && opts.length) {
        for (var i = 0; i < opts.length; i++) {
          var o = opts[i];
          if (o && o.name && /^size$/i.test(String(o.name).trim()) && o.value) {
            return String(o.value);
          }
        }
      }
      var vt = item.variant_title;
      if (vt && String(vt).trim() && String(vt).trim().toLowerCase() !== 'default title') {
        return String(vt).trim();
      }
      return '';
    }

    function injectCartLineSizes(cart) {
      var ext = document.getElementById('amp-theme-extension');
      if (!ext || !cart || !cart.items) return;

      var titles = ext.querySelectorAll('.amp-cart__cart-line-title');
      if (!titles.length) return;

      var lang = detectLang();
      var pack = COPY[lang] || COPY.en;
      var sizeLine = pack.sizeLine || function (l) {
        return 'Size: ' + l;
      };

      for (var i = 0; i < titles.length; i++) {
        var item = cart.items[i];
        var label = sizeLabelFromLineItem(item);
        var titleEl = titles[i];
        var line =
          titleEl.closest('.amp-cart__cart-line') ||
          titleEl.closest('[class*="amp-cart__cart-line"]');
        var existing =
          titleEl.nextElementSibling &&
          titleEl.nextElementSibling.classList &&
          titleEl.nextElementSibling.classList.contains('wyde-amp-figma-cart-line-size')
            ? titleEl.nextElementSibling
            : line
              ? line.querySelector('.wyde-amp-figma-cart-line-size')
              : null;

        if (!label) {
          if (existing && existing.parentNode) existing.parentNode.removeChild(existing);
          continue;
        }

        var text = sizeLine(label);
        if (existing) {
          existing.textContent = text;
          continue;
        }

        var div = document.createElement('div');
        div.className = 'wyde-amp-figma-cart-line-size';
        div.setAttribute('data-wyde-figma-size', '1');
        div.textContent = text;
        titleEl.parentNode.insertBefore(div, titleEl.nextSibling);
      }
    }

    function updateProgressBanner() {
      var rewards = document.querySelector('#amp-theme-extension .amp-cart__rewards');
      if (!rewards) return;

      if (progressFetchTimer) clearTimeout(progressFetchTimer);
      progressFetchTimer = setTimeout(function () {
        progressFetchTimer = null;
        fetchCartAugmentations();
      }, 200);
    }

    function fetchCartAugmentations() {
      fetch('/cart.js')
        .then(function (r) {
          return r.json();
        })
        .then(function (cart) {
          applyProgressFromCart(cart);
          syncFooterShippingFromCart(cart);
          injectCartLineSizes(cart);
        })
        .catch(function () {});
    }

    function updateFooterShippingDisplay(freeShippingUnlocked) {
      var el = document.querySelector(
        '#amp-theme-extension .amp-cart__footer-row--shipping-value'
      );
      if (!el) return;

      var lang = detectLang();
      var pack = COPY[lang] || COPY.en;
      var atCheckout = pack.shippingAtCheckout || 'Calculated at checkout';
      var freeLabel = pack.shippingFree || 'Free';

      if (freeShippingUnlocked) {
        el.textContent = freeLabel;
        el.classList.add('wyde-amp-figma-shipping-value--free');
      } else {
        el.textContent = atCheckout;
        el.classList.remove('wyde-amp-figma-shipping-value--free');
      }
    }

    /** Same threshold logic as the free-shipping progress bar */
    function syncFooterShippingFromCart(cart) {
      if (!cart || !cart.currency) {
        updateFooterShippingDisplay(false);
        return;
      }
      var thresh = thresholdFor(cart.currency);
      if (thresh == null || thresh <= 0) {
        updateFooterShippingDisplay(false);
        return;
      }
      var remaining = thresh - (cart.total_price || 0);
      updateFooterShippingDisplay(remaining <= 0);
    }

    function applyProgressFromCart(cart) {
      var rewards = document.querySelector('#amp-theme-extension .amp-cart__rewards');
      if (!rewards) return;

      if (!cart || !cart.currency) {
        removeProgressWrap(rewards);
        return;
      }

      var thresh = thresholdFor(cart.currency);
      if (thresh == null || thresh <= 0) {
        removeProgressWrap(rewards);
        return;
      }

      var subtotal = cart.total_price || 0;
      var remaining = thresh - subtotal;
      var lang = detectLang();
      var pack = COPY[lang] || COPY.en;
      var textEl;
      var fillEl;
      var wrap = ensureProgressWrap(rewards);

      textEl = wrap.querySelector('.wyde-amp-figma-rewards-text');
      fillEl = wrap.querySelector('.wyde-amp-figma-progress-fill');

      if (remaining <= 0) {
        wrap.classList.add('wyde-amp-figma-progress-wrap--complete');
        textEl.innerHTML = pack.progressDone;
      } else {
        wrap.classList.remove('wyde-amp-figma-progress-wrap--complete');
        var money = formatProgressRemainingMoney(cart, remaining);
        textEl.innerHTML = pack.progressRemainingHtml(money);
      }

      var pct = Math.min(100, Math.max(0, (subtotal / thresh) * 100));
      if (fillEl) fillEl.style.width = pct + '%';

      rewards.dataset.wydeFigmaProgress = '1';
    }
  
    /**
     * AMP React sets style="background: rgb(255, 255, 255)" on the discount box.
     * That paints a white band; override with setProperty(…, 'important').
     */

    /**
     * Wrap the top section of the drawer in a scroll host so `.amp-cart-drawer--scrollable`
     * can stay overflow:hidden while a single middle region scrolls (AMP nests everything
     * under one scroll container). USP + coupon + footer stay pinned below the host.
     *
     * - Desktop (>=750px): scroll host wraps `.amp-cart__cart-lines` only.
     * - Mobile  (<750px):  scroll host wraps header + rewards (+ upsell) + cart-lines so
     *   the “Cart x” title + free-shipping progress also scroll with the products.
     */
    function ensureCartLinesScrollHost() {
      var scroll = document.querySelector('#amp-theme-extension .amp-cart-drawer--scrollable');
      var lines = document.querySelector('#amp-theme-extension .amp-cart__cart-lines');
      if (!scroll || !lines) return;

      var isMobile = window.matchMedia('(max-width: 749px)').matches;
      var mode = isMobile ? 'mobile' : 'desktop';
      var existingHost = scroll.querySelector('.wyde-amp-figma-lines-scroll-host');

      if (existingHost && wydeAmpScrollLayoutMode === mode) {
        return;
      }

      if (existingHost) {
        while (existingHost.firstChild) {
          existingHost.parentNode.insertBefore(existingHost.firstChild, existingHost);
        }
        existingHost.parentNode.removeChild(existingHost);
      }

      wydeAmpScrollLayoutMode = mode;

      var targets;
      if (isMobile) {
        targets = [
          scroll.querySelector('.amp-cart__header'),
          scroll.querySelector('.amp-cart__rewards'),
          scroll.querySelector('.amp-cart__upsell'),
          lines
        ].filter(Boolean);
      } else {
        targets = [lines];
      }

      var host = document.createElement('div');
      host.className = 'wyde-amp-figma-lines-scroll-host';
      host.setAttribute('data-wyde-lines-scroll', '1');
      targets[0].parentNode.insertBefore(host, targets[0]);
      for (var j = 0; j < targets.length; j++) {
        host.appendChild(targets[j]);
      }
    }

    /**
     * Only the lines scroll host scrolls — `.amp-cart-drawer--scrollable` must not.
     * USP / coupon / footer stay pinned below the product list at all widths.
     */
    function applyCartDrawerScrollIsolation() {
      var ext = document.getElementById('amp-theme-extension');
      var inner = ext && ext.querySelector('.amp-cart-drawer__inner');
      var scroll = ext && ext.querySelector('.amp-cart-drawer--scrollable');
      var lines = ext && ext.querySelector('.amp-cart__cart-lines');
      var host = ext && ext.querySelector('.wyde-amp-figma-lines-scroll-host');

      if (!lines) return;

      // Only style the inner shell — NEVER `.amp-cart-drawer` / `.amp-cart`
      // (those own the right-side fixed positioning).
      function col(el) {
        if (!el) return;
        el.style.setProperty('display', 'flex', 'important');
        el.style.setProperty('flex-direction', 'column', 'important');
        el.style.setProperty('min-height', '0', 'important');
        el.style.setProperty('height', '100%', 'important');
        el.style.setProperty('max-height', '100dvh', 'important');
        el.style.setProperty('overflow', 'hidden', 'important');
      }

      col(inner);
      col(scroll);

      if (host) {
        host.style.setProperty('flex', '1 1 auto', 'important');
        host.style.setProperty('min-height', '0', 'important');
        host.style.setProperty('overflow-x', 'hidden', 'important');
        host.style.setProperty('overflow-y', 'auto', 'important');
        host.style.setProperty('-webkit-overflow-scrolling', 'touch', 'important');
        host.style.setProperty('overscroll-behavior', 'contain', 'important');
      }

      if (lines) {
        lines.style.removeProperty('flex');
        lines.style.removeProperty('min-height');
        lines.style.removeProperty('overflow-y');
        lines.style.removeProperty('overflow');
      }
    }

    function fixAmpInlineBackgrounds() {
      var ext = document.getElementById('amp-theme-extension');
      if (!ext) return;
  
      function paint(el, color) {
        if (!el) return;
        el.style.setProperty('background-color', color, 'important');
        el.style.setProperty('background', color, 'important');
      }
  
      paint(ext.querySelector('.amp-cart-drawer__inner'), '#f2f2f2');
      paint(ext.querySelector('.amp-cart-drawer--scrollable'), '#f2f2f2');
      paint(ext.querySelector('.amp-cart__rewards'), '#ffffff');
      paint(ext.querySelector('.wyde-amp-figma-progress-wrap'), '#ffffff');
      paint(ext.querySelector('.amp-cart__footer'), '#f2f2f2');
  
      paint(ext.querySelector('.amp-cart__header'), '#ffffff');
      paint(ext.querySelector('.amp-cart__cart-lines'), '#ffffff');
  
      var db = ext.querySelector('.amp-cart__discount-box');
      paint(db, '#f2f2f2');
  
      var ttl = ext.querySelector('.amp-cart__discount-box-title');
      paint(ttl, '#f2f2f2');
  
      var usp = ext.querySelector('.wyde-amp-figma-usp');
      paint(usp, '#f2f2f2');
  
      var upsells = ext.querySelectorAll('.amp-cart__upsell');
      for (var i = 0; i < upsells.length; i++) {
        var u = upsells[i];
        if (u.children && u.children.length === 0) {
          u.style.setProperty('display', 'none', 'important');
          u.style.setProperty('height', '0', 'important');
          u.style.setProperty('min-height', '0', 'important');
          u.style.setProperty('margin', '0', 'important');
          u.style.setProperty('padding', '0', 'important');
          u.style.setProperty('overflow', 'hidden', 'important');
          u.style.setProperty('background', 'transparent', 'important');
        }
      }
    }
  
    function hideContinueShopping() {
      var nodes = document.querySelectorAll(
        '#amp-theme-extension .amp-cart__footer-continue-link, #amp-theme-extension [class*="footer-continue"]'
      );
      for (var i = 0; i < nodes.length; i++) {
        nodes[i].style.setProperty('display', 'none', 'important');
        nodes[i].setAttribute('aria-hidden', 'true');
      }
    }
  
    function ensurePaymentIcons() {
      var footer = document.querySelector('#amp-theme-extension .amp-cart__footer');
      if (!footer || footer.querySelector('.wyde-amp-figma-pay-icons')) return;
  
      var btn = footer.querySelector('.amp-cart__footer-checkout-button');
      if (!btn || !btn.parentNode) return;
  
      var row = document.createElement('div');
      row.className = 'wyde-amp-figma-pay-icons';
      row.setAttribute('aria-hidden', 'true');
      var P = PAY_CARD_IMG;
      function payMark(title, src, w, h) {
        var width = w != null ? w : 32;
        var height = h != null ? h : 20;
        return (
          '<img class="wyde-amp-figma-pay__img" src="' +
          src +
          '" alt="' +
          title +
          '" title="' +
          title +
          '" width="' +
          width +
          '" height="' +
          height +
          '" loading="lazy" decoding="async" />'
        );
      }
  
      row.innerHTML =
        '<div class="wyde-amp-figma-pay-icons__row">' +
        payMark('Visa', P.visa) +
        payMark('American Express', P.amex) +
        payMark('Mastercard', P.mc) +
        payMark('Apple Pay', P.apple) +
        payMark('Google Pay', P.google) +
        payMark('PayPal', P.paypal) +
        payMark('Shop Pay', P.shop) +
        '</div>';
  
      if (btn.nextSibling) {
        btn.parentNode.insertBefore(row, btn.nextSibling);
      } else {
        btn.parentNode.appendChild(row);
      }
    }
  
    var runTimer = null;
    function run() {
      if (window.__WYDE_UPCART__ && typeof window.__WYDE_UPCART__.isActive === 'function') {
        try {
          if (window.__WYDE_UPCART__.isActive()) return;
        } catch (_) {}
      }
      if (!document.querySelector('#amp-theme-extension .amp-cart')) {
        wydeAmpScrollLayoutMode = null;
        return;
      }
      ensureCartLinesScrollHost();
      ensureUspStrip();
      wireCouponAccordion();
      updateProgressBanner();
      ensurePaymentIcons();
      hideContinueShopping();
      fixAmpInlineBackgrounds();
      applyCartDrawerScrollIsolation();
    }
  
    function scheduleRun() {
      if (runTimer) clearTimeout(runTimer);
      runTimer = setTimeout(run, 220);
    }

    function bindAmpSubtreeObserver() {
      var ext = document.getElementById('amp-theme-extension');
      if (!ext || ext.dataset.wydeAmpFigmaSubtreeObs) return;
      ext.dataset.wydeAmpFigmaSubtreeObs = '1';
      var ampObs = new MutationObserver(function () {
        scheduleRun();
      });
      ampObs.observe(ext, { childList: true, subtree: true });
    }

    var bootAmpObs = new MutationObserver(function () {
      bindAmpSubtreeObserver();
    });
    bootAmpObs.observe(document.documentElement, { childList: true, subtree: true });
    bindAmpSubtreeObserver();

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', scheduleRun);
    } else {
      scheduleRun();
    }

    window.addEventListener('resize', scheduleRun, { passive: true });
  })();